import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import WidgetsPrecogCard from "./card";
import { useDispatch } from "react-redux";
import moment from "moment";
import { highlightsCounter } from "../../../store/actions/precog/highlights";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { Divider } from "antd";
import StandingHuman from "../../../assets/img/standing.svg";

const WidgetEvidence = () => {
  const dispatch = useDispatch();
  const [highlights, setHighlights] = useState(null);

  useEffect(() => {
    dispatch(highlightsCounter()).then((res) => {
      setHighlights(res);
    });
  }, []);

  return (
    <WidgetsPrecogCard isEmpty={false}>
      <div className="title">
        <FormattedMessage id="preCog.widget.evidence.title"/>
      </div>
      <div>
        <strong><FormattedMessage id="preCog.widget.evidence.registrationDate"/></strong>
        <div>{
          highlights?.lastRegistrationDate === null ? 
            <FormattedMessage id="generic.notAvailable" /> : 
            moment(highlights?.lastRegistrationDate).format(DATE_FORMAT_FOR_DISPLAY)}
        </div>
        <Divider style={{height: "100%", margin: "8px 0"}} />
        <strong><FormattedMessage id="preCog.widget.evidence.documentsContains"/></strong>
        {Object.values(highlights?.featuredDrafts || {}).every(el => el === 0) ? 
          <div style={{marginTop: "9px"}}>
            <FormattedMessage id="preCog.widget.evidence.nonRegisteredMessage" />
          </div>
          :
          (
            <div style={{marginTop: "9px"}}>
              <div style={{marginBottom: "8px"}}>
                {!!highlights?.featuredDrafts?.withWithHoldings && (
                  <div><FormattedMessage id="preCog.widget.evidence.withHoldings" /> (<span style={{color: "#0090d1"}}>
                    {highlights?.featuredDrafts?.withWithHoldings}
                  </span>)
                  </div>
                )}
              </div>
              <div style={{marginBottom: "8px"}}>
                {!!highlights?.featuredDrafts?.withIntrastat && (
                  <div>
                    <FormattedMessage id="preCog.widget.evidence.intrastat" /> (<span style={{color: "#0090d1"}}>
                      {highlights?.featuredDrafts?.withIntrastat}
                    </span>)
                  </div>
                )}
              </div>
              <div style={{marginBottom: "8px"}}>
                {!!highlights?.featuredDrafts?.withAssets && (
                  <div>
                    <FormattedMessage id="preCog.widget.evidence.assets" /> (<span style={{color: "#0090d1"}}>
                      {highlights?.featuredDrafts?.withAssets}
                    </span>)
                  </div>
                )}
              </div>
            </div>
          )}
        {!!highlights?.lastRegistrationDate === false && <div style={{position: "absolute", right: "0", bottom: "0", paddingRight: "15px", paddingBottom: "5px"}}>
          <img style={{width: "50px"}} src={StandingHuman} alt="logo-human" />
        </div>}
      </div>
    </WidgetsPrecogCard>
  );
};

export default WidgetEvidence;